import { green, blueGrey, red, yellow, lightBlue, grey, purple, deepPurple, teal, indigo, orange } from '@mui/material/colors';
import { rgba } from 'framer-motion';

const defColors = {
    backgroundColor: 'rgba(22, 28, 36, 1)',
    bgGradient: 'linear-gradient(to bottom, #1C2355 0%, #0C0E1E 20%)',
    innerBox:['#292F47','#1B2138'],
    background:
     `repeating-linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3) 1px, transparent 1px, transparent 15px), 
      repeating-linear-gradient(to right,  rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3) 1px, transparent 1px, transparent 15px),
      radial-gradient(ellipse closest-side, rgb(10, 10, 10), rgb(15, 15, 15), rgb(22, 28, 36))`,    
    fontColor: '#bbdefb',
    //mainTitleBackground: 'radial-gradient(ellipse closest-side, rgba(0, 0, 0, 1), rgb(22, 28, 36))',
    mainTitleBackground1: 'linear-gradient(to bottom, rgb(33, 42, 54), rgb(22, 28, 36), rgb(11, 14, 18), rgb(11, 14, 18), rgb(11, 14, 18), rgb(22, 28, 36), rgb(33, 42, 54))',
    mainTitleBackground2: 'linear-gradient(to bottom, rgb(80, 80, 80), rgb(33, 42, 54), rgb(33, 42, 54), rgb(33, 42, 54), rgb(80, 80, 80))',
    validColors: ['#52b202', '#ff3d00'],
    validColorFunc: (valid) => valid ? 'rgba(9, 188, 113, 0.3)' : 'rgba(255, 60, 53, 0.3)',
    validColorFuncBd: (valid) => valid ? 'rgba(9, 188, 113)' : 'rgba(255, 60, 53)',
    chipSelectedColorFunc: (selected) => selected ? '#394CFF':'#434661',
    chipSelectedfont:(selected) => selected ? '#fff':'rgba(255, 255, 255, 0.5)',
    trafficColors: [red[500], yellow[800], green[700], grey[700]],    
    bus:{ code30:'#FFFF00', code12:'#b26a00', code13:'#8bc34a', code14:'#f44336', station:'rgba(100, 100, 200, 1.0)'},
    serverStatus: [green[700], blueGrey[500], lightBlue[900]],   
    facilityColors: [purple[500], blueGrey[500], deepPurple[500], teal[500], indigo[500], orange[500]] 
  };

export default defColors
  